export default __webpack_public_path__ + "static/media/tdee-eq-1.ecabc7fc.png";